export const fromSmall = '@media (min-width: 700px)'
export const fromMedium = '@media (min-width: 1000px)'
export const fromLarge = '@media (min-width: 1200px)'
